import { GroupContentComponent, ListContentComponent } from '@wix/funnel-builder-lizard'
import { ReactNode } from 'react'

import { SidePanelProps } from './CommonTemplateSidePanel'

export enum ContentType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  TITLE = 'TITLE',
  LIST_ITEM = 'LIST_ITEM',
  LIST = 'LIST',
  TEXT = 'TEXT',
  CENTERED_TEXT = 'CENTERED_TEXT',
}

export type ContentItem = {
  // ContentType.LIST requires special treatment.
  type: Exclude<ContentType, ContentType.LIST>
  content: string
}

export type SidePanelContent = GroupContentComponent<{
  items: ListContentComponent<ContentItem>
  background: string
  color: string
}>

export type SidePanelContentProps = {
  content?: SidePanelContent[]
  activeIndex?: number
  className?: string
  dataHook?: string
  logos?: boolean
  children?: ReactNode
} & Pick<SidePanelProps, 'textMaxWidth' | 'textAlign' | 'imageMarginBottom'>
